import { z } from 'zod';

/** Источник ответа: книга, страница и найденный фрагмент. */
export interface ContextChunkModel {
  readonly book: string;
  readonly pageNumber: number;
  readonly answer: string;
}

/** `page_number` -> `pageNumber`, поэтому объект проходит через `.transform()`. */
export const contextChunkModelSchema = z
  .object({
    book: z.string(),
    page_number: z.number(),
    answer: z.string(),
  })
  .transform(
    (json): ContextChunkModel => ({
      book: json.book,
      // `(json['page_number'] as num).toInt()` — Dart усекает дробную часть.
      pageNumber: Math.trunc(json.page_number),
      answer: json.answer,
    }),
  );

export function contextChunkModelFromJson(json: unknown): ContextChunkModel {
  return contextChunkModelSchema.parse(json);
}

export function contextChunkModelToJson(
  model: ContextChunkModel,
): Record<string, unknown> {
  return {
    book: model.book,
    page_number: model.pageNumber,
    answer: model.answer,
  };
}
